import Component from "../../lib/component";
import Tracker from "../../lib/tracker";
import { getTrackerOptions } from "../../lib/tracker_helpers";

export const DirectionsBtnConfig = {
  componentTypeKey: "DirectionsBtn",
  baseHtmlClass: "directions_btn",
  selector: ".directions_btn",

  datasetConfigKey: "directions_btn__config",

  directionsSelectedEventNameKey: "EXPERIENCE_DIRECTIONS_SELECTED",
  analyticsParametersDatasetConfigKey: "analytics_parameters",
  trackerOptionsDatasetConfigKey: "tracker_options",
};

export class DirectionsBtn extends Component {
  static get config() {
    return DirectionsBtnConfig;
  }

  constructor(id_or_element) {
    super({
      element: id_or_element,
      config: DirectionsBtn.config,
    });

    this.setDatasetConfig(DirectionsBtn.config.datasetConfigKey);

    this.analyticsParameters = this.getAnalyticsParameters();
    this.trackerOptions = getTrackerOptions(
      this.getDatasetConfigValue(
        DirectionsBtn.config.trackerOptionsDatasetConfigKey,
      ),
    );
    this.tracker = new Tracker(window, document, this.trackerOptions);

    this.eventName =
      this.tracker.eventNames[
        DirectionsBtn.config.directionsSelectedEventNameKey
      ];
    if (typeof this.eventName === "undefined")
      console.warn(
        "[DirectionsBtn] Event name could not be found! Available options are: ",
        this.tracker?.eventNames,
      );

    this.element.addEventListener("click", this.handleClick.bind(this));
  }

  handleClick(event) {
    event.preventDefault(); // Stop the default link behavior
    this.trackDirectionsSelectedEvent();

    // Let the event flush before navigation
    const href = this.element.getAttribute("href");
    if (href) {
      setTimeout(() => {
        window.location.href = href;
      }, 150); // ~150ms is usually sufficient to allow the event to be sent before navigation away
    }
  }

  trackDirectionsSelectedEvent() {
    if (!this.tracker || !this.tracker.eventTracker) return;
    if (!this.eventName) return;
    this.tracker.eventTracker(this.eventName, this.analyticsParameters);
  }

  getAnalyticsParameters() {
    const parameters = this.getDatasetConfigValue(
      DirectionsBtn.config.analyticsParametersDatasetConfigKey,
    );
    if (!parameters) return;
    return parameters;
  }
}
